import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { ShieldAlert } from 'lucide-react';
import { BowtieNode } from '../bowtie.types';

export const TopEventNode: React.FC<{ data: BowtieNode }> = memo(({ data }) => {
  return (
    <div
      style={{
        background: 'linear-gradient(135deg, #1e1b4b 0%, #312e81 100%)',
        border: '3px solid #6366f1',
        borderRadius: '16px',
        padding: '16px 20px',
        width: '300px',
        boxSizing: 'border-box',
        color: '#ffffff',
        boxShadow: '0 10px 25px -5px rgba(99, 102, 241, 0.4), 0 8px 10px -6px rgba(99, 102, 241, 0.2)',
        textAlign: 'center',
        position: 'relative',
      }}
    >
      <Handle id="top" type="target" position={Position.Top} style={{ background: '#f59e0b', width: 10, height: 10 }} />
      <Handle id="left" type="target" position={Position.Left} style={{ background: '#3b82f6', width: 10, height: 10 }} />

      <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', background: 'rgba(255,255,255,0.15)', padding: '3px 10px', borderRadius: '12px', fontSize: '11px', fontWeight: 700, letterSpacing: '0.8px', textTransform: 'uppercase', color: '#c7d2fe', marginBottom: '8px' }}>
        <ShieldAlert size={14} />
        <span>TOP EVENT (CRITICAL LOSS)</span>
      </div>

      <div style={{ fontWeight: 700, fontSize: '15px', lineHeight: 1.3, color: '#ffffff' }}>
        {data.label}
      </div>

      {data.metadata?.eli5 && (
        <div style={{ fontSize: '11px', color: '#cbd5e1', marginTop: '6px', lineHeight: 1.3 }}>
          {data.metadata.eli5}
        </div>
      )}

      {data.metadata?.details && data.metadata.details.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', justifyContent: 'center', marginTop: '10px' }}>
          {data.metadata.details.map((d, i) => (
            <span key={i} style={{ background: 'rgba(99, 102, 241, 0.3)', border: '1px solid rgba(165, 180, 252, 0.3)', borderRadius: '6px', padding: '2px 6px', fontSize: '10px', color: '#e0e7ff' }}>
              {d}
            </span>
          ))}
        </div>
      )}

      <Handle id="right" type="source" position={Position.Right} style={{ background: '#ec4899', width: 10, height: 10 }} />
    </div>
  );
});
